














































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import ITransformations from '@/store/models/ITransformations';
// import ICustomer from '@/store/models/ICustomer';
import IWarehouse from '@/store/models/IWarehouse';
import IListStatusTransformation from '@/store/models/IListStatusTransformation';
import moment from 'moment';
import IStock from '@/store/models/IStock';

@Component({
    components: {
        Snackbar
    }
})
export default class TransformationsSelector extends Vue {
     searchTransformation: string = "";
    dialog: boolean = false;
    dialogStatus : boolean = false;
    isValid: boolean = true;
    isValidStatus: boolean = true;
    sortBy: string = 'dateTransform';
    sortDesc: boolean = true;
    showCompletedTransformation: boolean = false;
    selectedTransformation: ITransformations[] = [];
    selectedStatusTransformation: IListStatusTransformation = {} as IListStatusTransformation;
    inboundSelected: string = "";
    selectedInbound: IStock = {} as IStock;
    selectedWarehouse: IWarehouse = {} as IWarehouse;
    dateTransformation: string = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    menu2: boolean = false;
    originalStatusId: string = "";
    originalStatusName: string = "";
    headers: any = [
        { text: 'Customer', align: 'start', value: 'customerSourceName' },
        { text: 'Inb. Code', value: 'inboundCode' },
        { text: 'Inb. Code Destination', value: 'codeDestination' },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Date transform', value: 'dateTransform' },
        { text: 'Status', value: 'statusName' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : ITransformations = {
        id: "",
        idCustomer: "",
        customerSourceName: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idListStatusTransformation: "",
        statusName: "",
        idInbound: "",
        inboundCode: "",
        idWarehouse: "",
        warehouseName: "",
        dateTransform: new Date()
    }
    defaultItem : ITransformations = {
        id: "",
        idCustomer: "",
        customerSourceName: "",
        idCompanySource: "",
        companySourceName: "",
        idCompanyDestination: "",
        companyDestinationName: "",
        idListStatusTransformation: "",
        statusName: "",
        idInbound: "",
        inboundCode: "",
        idWarehouse: "",
        warehouseName: "",
        dateTransform: new Date()
    }

    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    TransformationList !: ITransformations[];
    @Prop({ type: Array, required: true })
    StockList !: IStock[];
    // @Prop({ type: Array, required: true })
    // CustomerList !: ICustomer[];
    @Prop({ type: Array, required: true })
    WarehouseList !: IWarehouse[];
    @Prop({ type: Array, required: true })
    StatusTransformationList !: IListStatusTransformation[];
    @Prop()
    value !: ITransformations;
    @Prop({ type: Boolean, default: false })
    HasDetails !: boolean;

    get formTitle() { return this.editedIndex === -1 ? 'New Transformation' : 'Edit Transformation'; }
    get DateTransformationFormatted() {
        let date: Date = new Date(this.MinDateToTransform);
        if (date > new Date(Date.now())) {
            this.dateTransformation = this.MinDateToTransform;
            return this.formatDate(this.MinDateToTransform);
        }
        return this.formatDate(this.dateTransformation);
    }
    get MinDateToTransform() {
        if (this.inboundSelected === "") {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        }

        let inboundIndex: number = this.StockList.findIndex(i => i.codeInbounds === this.inboundSelected || i.codeDestination === this.inboundSelected);
        if (inboundIndex !== -1) {
            this.selectedInbound = this.StockList[inboundIndex];
        }

        if (this.selectedInbound.dateIn === undefined) {
            return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        }
        if (this.selectedTransformation.length > 0) {
            const dateTransformation = new Date(this.selectedTransformation[0].dateTransform);
            return (new Date(dateTransformation.setDate(dateTransformation.getDate()) - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        }
        const dateInbound = new Date(this.selectedInbound.dateIn);
        const datePlusDay = dateInbound.setDate(dateInbound.getDate() + 1);
        return (new Date(datePlusDay - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
    }

    get warehousesFiltered() {
        let inboundIndex: number = this.StockList.findIndex(i => i.codeInbounds === this.inboundSelected || i.codeDestination === this.inboundSelected);
        if (inboundIndex !== -1) {
            this.selectedInbound = this.StockList[inboundIndex];
        }
        let stock = this.StockList.filter(x => x.idInbound === this.selectedInbound.idInbound);
        let warehousesIds = this.getUniqueIds(stock);
        let result: IWarehouse[] = [];
        warehousesIds.forEach(d => {
            let warehouse = this.WarehouseList.find(w => w.id === d) as IWarehouse;
            result.push(warehouse);
        });
        return result;
    }

    get inboundItems(): string[] {
        let inboundsCode: string[] = this.StockList.map(t => t.codeInbounds);
        let inboundsCodeDestination: string[] = this.StockList.map(t => t.codeDestination);
        
        return inboundsCode
        .concat(inboundsCodeDestination)
        .filter(code => code) // Filtra valores nulos o undefined
        .sort((a, b) => a.localeCompare(b));
    }

    get isCurrentStatusExternal(): boolean {
        if (this.editedIndex === -1) return false;
        if (!this.editedItem || !this.editedItem.idListStatusTransformation) return false;
        if (!this.StatusTransformationList || this.StatusTransformationList.length === 0) return true;

        const exists = this.StatusTransformationList.some(s => s.id === this.editedItem.idListStatusTransformation);
        return !exists;
    }

    get currentStatusHint(): string {
        if (this.isCurrentStatusExternal) {
            return "This status was set by another company. You can still change it to one of your company statuses.";
        }
        return "This is the current status. You can change it to another status defined in your company.";
    }

    private applyStatusIfValid() {
        if (!this.selectedStatusTransformation || !this.selectedStatusTransformation.id) return;
        const exists = this.StatusTransformationList && this.StatusTransformationList.some(s => s.id === this.selectedStatusTransformation!.id);
        if (!exists) return;

        this.editedItem.idListStatusTransformation = this.selectedStatusTransformation.id;
        this.editedItem.statusName = this.selectedStatusTransformation.name;
    }

    getUniqueIds(items: any[]) {
        const uniqueIds = new Set();
        items.forEach(item => uniqueIds.add(item.idWarehouse));
        return Array.from(uniqueIds);
    }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    @Watch('value')
    updateSelection(newValue : ITransformations | null) {
        if (!newValue || Object.keys(newValue).length === 0) {
            this.selectedTransformation = [];
        } else {
            this.selectedTransformation = [newValue];
            this.$emit('transformationChanged', this.selectedTransformation[0]);
        }
    }

    @Watch('showCompletedTransformation')
    onChangeShowCompletedTransformations() {
        this.$emit('showCompletedTransformation', this.showCompletedTransformation);
    }
    
    formatDate (date: string) {
        if (!date) return null;

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    select(item : ITransformations) : void {
        let index : number = this.selectedTransformation.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.selectedTransformation = [item];
            this.$emit('input', item);
        } else {
            let transformation = this.selectedTransformation.find(w => w.id === item.id);
            if (!transformation) {
                this.selectedTransformation = [];
                this.$emit('input', null);
            }
        }
    }

    // ✅ EDIT: snapshot + status local only (si status actual es externo -> selector vacío)
    editTransformation(item: ITransformations, dbox = true) {
        if (this.selectedTransformation.length > 0) {
            this.editedIndex = this.TransformationList.findIndex(i => i.id === item.id);

            // inbound / warehouse / fecha
            this.selectedInbound = this.StockList.find(i => i.idInbound === item.idInbound) as IStock;
            this.inboundSelected = item.inboundCode;
            this.selectedWarehouse = this.WarehouseList.find(w => w.id === item.idWarehouse) as IWarehouse;
            this.dateTransformation = moment(new Date(item.dateTransform)).format('YYYY-MM-DD');

            // item
            this.editedItem = Object.assign({}, item);

            // ✅ Snapshot status real (para revertir UI si el padre rechaza)
            this.originalStatusId = item.idListStatusTransformation;
            this.originalStatusName = item.statusName;

            // ✅ Selector: solo status local (si el status actual es externo -> queda vacío)
            const localStatus = this.StatusTransformationList.find(s => s.id === item.idListStatusTransformation);
            this.selectedStatusTransformation = localStatus || ({} as IListStatusTransformation);

            this.dialog = true;
            this.dialogStatus = false;
        }
    }

    // ✅ SAVE: aplicar status solo si es local + emitir con callback (padre decide)
    // Si el padre rechaza: revertir status y NO cerrar modal.
    saveTransformation() {
        const formOk = (this.$refs.form as Vue & { validate: () => boolean }).validate();
        if (!formOk) {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
            return;
        }

        // ✅ Guardamos campos principales
        this.editedItem.idCustomer = this.selectedInbound.idCustomer;
        this.editedItem.customerSourceName = this.selectedInbound.customerName;
        this.editedItem.dateTransform = new Date(this.dateTransformation);

        this.editedItem.idInbound = this.selectedInbound.idInbound;
        this.editedItem.inboundCode = this.selectedInbound.codeInbounds;

        this.editedItem.idCompanySource = this.selectedInbound.idCompanySource;
        this.editedItem.idCompanyDestination = this.selectedInbound.idCompanyDestination;

        this.editedItem.warehouseName = this.selectedWarehouse.name;
        this.editedItem.idWarehouse = this.selectedWarehouse.id;

        // ✅ Status: SOLO si el usuario seleccionó uno válido local
        // (requiere tener implementado applyStatusIfValid() como en la guía)
        this.applyStatusIfValid();

        // ✅ EDIT
        if (this.editedIndex > -1) {
            this.$emit('editTransformation', this.editedItem, (r: { success: boolean; transformation?: ITransformations }) => {
                if (r && r.success) {
                    // ✅ OK: cerramos modal
                    this.close();
                    return;
                }

                // ❌ Rechazado: revertir UI al status real y limpiar selector
                const fixed = r && r.transformation ? r.transformation : null;

                if (fixed) {
                    this.editedItem = Object.assign({}, fixed);
                    this.originalStatusId = fixed.idListStatusTransformation;
                    this.originalStatusName = fixed.statusName;
                } else {
                    // fallback
                    this.editedItem.idListStatusTransformation = this.originalStatusId;
                    this.editedItem.statusName = this.originalStatusName;
                }

                // limpiar selector para que no quede “Completed” visualmente
                this.selectedStatusTransformation = ({} as IListStatusTransformation);
            });

            // 👈 importante: NO cerrar aquí (se cierra solo si success)
            return;
        }

        // ✅ NEW
        // En creación, aquí normalmente sí quieres aplicar el status seleccionado (Pending por defecto)
        // Si no existe id (p.ej. no ha seleccionado), puedes forzar Pending
        if (this.selectedStatusTransformation && this.selectedStatusTransformation.id) {
            this.editedItem.idListStatusTransformation = this.selectedStatusTransformation.id;
            this.editedItem.statusName = this.selectedStatusTransformation.name;
        }

        this.$emit('saveTransformation', this.editedItem);
        this.close();
    }

    deleteTransformation(transformation: ITransformations) {
        if (this.selectedTransformation.length > 0) {
            this.$emit('deleteTransformation', transformation);
            this.close();
        }
    }

    resetTransformation() {
        this.selectedTransformation = [];
        this.dateTransformation = new Date().toISOString().substr(0, 10);
        this.selectedInbound = {} as IStock;
        this.inboundSelected = "";
        this.selectedStatusTransformation = this.StatusTransformationList.find(c => c.name === "Pending") as IListStatusTransformation;
        this.selectedWarehouse = {} as IWarehouse;
        this.$emit('resetTransformation');
    }
}
